<template>
    <front-layout title="Política de Privacidade">
        <div class="py-60 container xl:w-2/3 mx-auto px-4 text-lg relative text-justify">
            <div class="flex items-center space-x-2">
                <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
            </div>

            <div class="bg-white inline-block p-2 rounded-lg" id="pol_priv" v-html="pol_priv" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText"></div>

            <div v-html="pol_priv" v-else></div>
                
        </div>
    </front-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'
    import BgShape from '@/Components/BgShape'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            BgShape
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            pol_priv: String,
        },
        data() {
            return {
                enableEdit: false,
                form: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        methods: {
            updateText(e) {
                this.form.setting = e.target.id
                this.form.content = e.target.innerHTML,
                this.form.route = this.route().current()
            },
            updateSettings(e) {
                if(this.form.setting != '' && this.form.content != '' & this.form.route != '') {
                    this.form.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        },
    })
</script>
